
import { changeDurationLabel} from '@process-advisor/process-miner/api/methods/histogram/changeDurationLabel'
import { getDurationLabel} from '@process-advisor/process-miner/api/methods/histogram/changeDurationLabel'
import { generateHistogramArray } from '@process-advisor/process-miner/api/methods/histogram/generateHistogramArray'

export const histogramMethods = {
    changeDurationLabel,
    getDurationLabel,
    generateHistogramArray
};
